import { render, staticRenderFns } from "./select-goods.vue?vue&type=template&id=1b1bcd50&scoped=true"
import script from "./select-goods.vue?vue&type=script&lang=js"
export * from "./select-goods.vue?vue&type=script&lang=js"
import style0 from "./select-goods.vue?vue&type=style&index=0&id=1b1bcd50&prod&lang=scss"
import style1 from "./select-goods.vue?vue&type=style&index=1&id=1b1bcd50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1bcd50",
  null
  
)

export default component.exports